class MealsMenuUIModel {
  constructor({
    mealCode = null,
    mealName = null,
    mealDescription = null,
    mealImage = null,
    mealType = null,
  }) {
    this.mealCode = mealCode;
    this.mealName = mealName;
    this.mealDescription = mealDescription;
    this.mealImage = mealImage;
    this.mealType = mealType;
  }
}

export default MealsMenuUIModel;
